/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowLeft: {
  name: 'arrow-left';
  data: string;
} = {
  name: 'arrow-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.707 5.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
